import React from 'react'
import Creear_1 from '../../../assets/images/home_page_4/careers/06.png'
import Creear_2 from '../../../assets/images/home_page_4/careers/07.png'
import Creear_3 from '../../../assets/images/home_page_4/careers/08.png'
import { Link } from 'react-router-dom'

const Careerabout = () => {
    return (
        <>
            <section id="career-about-us" className="career-about-us-main-block">
                <div className="container">
                    <div className="career-about-us-block">
                        <div className="row align-items-center">
                            <div className="col-lg-5">
                                <div className="career-img-block">
                                    <div className="row align-items-center">
                                        <div className="col-lg-6 col-md-6">
                                            <img
                                                src={Creear_1}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <img
                                                src={Creear_2}
                                                className="img-fluid mb-3"
                                                alt=""
                                            />
                                            <img
                                                src={Creear_3}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 offset-lg-1">
                                <div className="career-about-us-dtls">
                                    <h3 className="sub-career-heading">About Us</h3>
                                    <h1 className="career-heading">
                                        Beyond The Ordinary, Career Extraordinary!
                                    </h1>
                                    <p className="about-career-dtls">
                                        A Business Finance consultant provides expert advice and
                                        assistance to businesses in managing their financial A Business
                                        Finance
                                    </p>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <ul className="career-lst">
                                                <li>
                                                    <i className="flaticon-check-mark" />
                                                    Profit Maximizers
                                                </li>
                                                <li>
                                                    <i className="flaticon-check-mark" />
                                                    Financial Performance
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col-lg-6">
                                            <ul className="career-lst">
                                                <li>
                                                    <i className="flaticon-check-mark" />
                                                    Insurance Planning
                                                </li>
                                                <li>
                                                    <i className="flaticon-check-mark" />
                                                    Business Loan Consultation
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <Link to="/Aboutus" className="btn btn-primary career-read-btn">
                                        Read more
                                        <i className="flaticon-right-arrows" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Careerabout
